import { graphql } from '@revelio/data-access';

export const CreateReportsMutation = graphql(`
  mutation createReports($input: CreateReportRequest!) {
    createReports(input: $input) {
      user_id
      report_id
    }
  }
`);

export const DeleteReportMutation = graphql(`
  mutation DeleteReport($id: String!) {
    deleteReport(id: $id)
  }
`);

export const RefreshReportMutation = graphql(`
  mutation RefreshReport($id: String!) {
    refreshReport(id: $id)
  }
`);
